import React, { useState } from "react";
import AuxilaryBoilersLog from "./auxilary-boilers";
import AuxilaryPurfierLog from "./auxilary-purfier";
import AuxilaryPumpLog from "./auxilary-pump";
import AuxilaryCompressorLog from "./auxilary-compressor";
import OtherMachinary from "./OtherMachinary";
import { RemarkAuxi } from "./RemarkAuxi";

function AuxilaryMachinaryLog() {
  const [activeTab, setActiveTab] = useState("auxiliary Boilers");

  const handleClick = (name) => {
    setActiveTab(name);
    localStorage.setItem("engineLogbook", name);
  };

  return (
    <>
      <div className="white-containers">
        <ul className="sub-marine-tabs">
          <li
            className={activeTab === "auxiliary Boilers" ? "active" : ""}
            onClick={() => handleClick("auxiliary Boilers")}
          >
            Boiler
          </li>
          <li
            className={activeTab === "auxiliary Purfier" ? "active" : ""}
            onClick={() => handleClick("auxiliary Purfier")}
          >
            Purifier
          </li>

          <li
            className={activeTab === "auxiliary Pump" ? "active" : ""}
            onClick={() => handleClick("auxiliary Pump")}
          >
            Pump
          </li>
          <li
            className={activeTab === "auxiliary Compressor" ? "active" : ""}
            onClick={() => handleClick("auxiliary Compressor")}
          >
            Air Compressor
          </li>
          <li
            className={activeTab === "OtherauxiliaryMachinary" ? "active" : ""}
            onClick={() => handleClick("OtherauxiliaryMachinary")}
          >
            Other Machinary
          </li>
          <li
            className={activeTab === "Remark" ? "active" : ""}
            onClick={() => handleClick("Remark")}
          >
            Remark
          </li>
        </ul>
      </div>
      <div className="white-container-contant">
        {activeTab == "auxiliary Boilers" && <AuxilaryBoilersLog />}
        {activeTab == "auxiliary Purfier" && <AuxilaryPurfierLog />}
        {activeTab == "auxiliary Pump" && <AuxilaryPumpLog  />}
        {activeTab == "auxiliary Compressor" && <AuxilaryCompressorLog  />}
        {activeTab == "OtherauxiliaryMachinary" && <OtherMachinary />}
        {activeTab == "Remark" && <RemarkAuxi  />}
        
      </div>
    </>
  );
}

export default AuxilaryMachinaryLog;
